/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 专业版增量功能接口（个税/生产经营/社保/资产对账/审计导出/旧账导入/盘点/资金单）</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月25日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//个税（综合所得）
	iit: {
		list(params = {}) {
			return Ajax.get('/iit-declare', params);
		},
		save(p) {
			return Ajax.post('/iit-declare', p);
		},
		summary(params = {}) {
			return Ajax.get('/iit-declare/summary', params);
		},
		missingCheck(params = {}) {
			return Ajax.get('/iit-declare/missing-check', params);
		}
	},
	//生产经营所得
	scjy: {
		list(params = {}) {
			return Ajax.get('/scjy-declare', params);
		},
		save(p) {
			return Ajax.post('/scjy-declare', p);
		},
		summary(params = {}) {
			return Ajax.get('/scjy-declare/summary', params);
		}
	},
	//社保费
	social: {
		list(params = {}) {
			return Ajax.get('/social-declare', params);
		},
		preview(params = {}) {
			return Ajax.get('/social-declare/preview', params);
		},
		submit(p) {
			return Ajax.post('/social-declare/submit', p);
		},
		wage(params = {}) {
			return Ajax.get('/social-declare/wage', params);
		}
	},
	//资产对账
	assetsCheck(params = {}) {
		return Ajax.get('/pro-report/assets-check', params);
	},
	//审计数据包下载地址
	auditUrl(year) {
		return `/api/audit-export?year=${year || ''}`;
	},
	//旧账导入模板下载地址
	syncTemplateUrl() {
		return '/api/sync/template';
	},
	//旧账导入
	syncImport(type, file) {
		let form = new FormData();
		form.append('type', type);
		form.append('file', file);
		return Ajax.post('/sync/import', form);
	},
	//存货盘点单
	inventoryCheck: {
		list(params = {}) {
			return Ajax.get('/inventory-check', params);
		},
		load(id) {
			return Ajax.get(`/inventory-check/${id}`);
		},
		save(p) {
			return Ajax.post('/inventory-check', p);
		},
		del(id) {
			return Ajax.delete(`/inventory-check/${id}`);
		},
		preview(ids) {
			return Ajax.post('/inventory-check/preview', {ids});
		},
		generate(ids) {
			return Ajax.post('/inventory-check/generate', {ids});
		}
	},
	//存货资金单
	inventoryFund: {
		list(params = {}) {
			return Ajax.get('/inventory-fund', params);
		},
		save(p) {
			return Ajax.post('/inventory-fund', p);
		},
		del(id) {
			return Ajax.delete(`/inventory-fund/${id}`);
		},
		preview(ids) {
			return Ajax.post('/inventory-fund/preview', {ids});
		},
		generate(ids) {
			return Ajax.post('/inventory-fund/generate', {ids});
		}
	},
	//内置存货模块（对齐线上：单据/存货/基础设置/期初/成本期间/报表/资金收款/配置）
	inventory: {
		//单据管理
		billList(params = {}) {
			return Ajax.get('/inventory/bill', params);
		},
		billSave(p) {
			return Ajax.post('/inventory/bill', p);
		},
		billLoad(id) {
			return Ajax.get(`/inventory/bill/${id}`);
		},
		billDel(id) {
			return Ajax.delete(`/inventory/bill/${id}`);
		},
		//存货档案
		stocks(params = {}) {
			return Ajax.get('/stocks', params);
		},
		stockSave(p) {
			return Ajax.post('/stocks', p);
		},
		//存货类别
		categoryList() {
			return Ajax.get('/inventory/category');
		},
		categorySave(p) {
			return Ajax.post('/inventory/category', p);
		},
		categoryDel(id) {
			return Ajax.delete(`/inventory/category/${id}`);
		},
		//单据类型
		billTypeList() {
			return Ajax.get('/inventory/bill-type');
		},
		billTypeSave(p) {
			return Ajax.post('/inventory/bill-type', p);
		},
		billTypeDel(id) {
			return Ajax.delete(`/inventory/bill-type/${id}`);
		},
		//计量单位
		unitList() {
			return Ajax.get('/inventory/unit');
		},
		unitSave(p) {
			return Ajax.post('/inventory/unit', p);
		},
		unitDel(id) {
			return Ajax.delete(`/inventory/unit/${id}`);
		},
		//存货科目映射
		mappingList() {
			return Ajax.get('/inventory/stocks-subject-mapping');
		},
		mappingSave(p) {
			return Ajax.post('/inventory/stocks-subject-mapping', p);
		},
		mappingDel(id) {
			return Ajax.delete(`/inventory/stocks-subject-mapping/${id}`);
		},
		//期初数据
		openingList() {
			return Ajax.get('/inventory/opening');
		},
		openingSave(list) {
			return Ajax.post('/inventory/opening', list);
		},
		//成本核算期间
		periodList(year) {
			return Ajax.get('/inventory/cost-period', {year});
		},
		periodCalculate(p) {
			return Ajax.post('/inventory/cost-period/calculate', p);
		},
		periodClose(p) {
			return Ajax.post('/inventory/cost-period/close', p);
		},
		//统计报表
		summary(params = {}) {
			return Ajax.get('/inventory/report/summary', params);
		},
		detail(params = {}) {
			return Ajax.get('/inventory/report/detail', params);
		},
		//资金收款单
		receiptList(params = {}) {
			return Ajax.get('/inventory/fund/receipt', params);
		},
		receiptSave(p) {
			return Ajax.post('/inventory/fund/receipt', p);
		},
		//规则配置
		numberRule() {
			return Ajax.get('/inventory/number-rule/load');
		},
		config() {
			return Ajax.get('/inventory/config');
		},
		configSave(p) {
			return Ajax.post('/inventory/config', p);
		}
	}
};
